


import TwCustomer from "../images/tw/customer.png"

import { UserLogoMapType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {



    tw: TwCustomer,
};
